import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative mt-1" }

import {computed, ref} from "vue";
import {
    Region,
} from "@/dtos";

import {Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions} from '@headlessui/vue';
import {CheckIcon} from '@heroicons/vue/20/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'TerritoriesAutocomplete',
  props: {
    territories: {
        type: Array,
        default: []
    },
    allowMultiple:{
        type: Boolean,
        default: false
    },
    modelValue: {
        type: Object,
        default: {}
    }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

// @ts-ignore
const props = __props

const emit = __emit

const territoryQuery = ref('');

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? props.territories
        : props.territories.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)


return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Combobox), {
      modelValue: __props.modelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = value => emit('update:modelValue', value)),
      multiple: __props.allowMultiple,
      as: "div"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ComboboxInput), {
            class: "w-full py-2 pl-3 pr-10 bg-white border border-clay-500 rounded-md shadow-sm focus:border-electric-500 focus:outline-hidden focus:ring-1 focus:ring-electric-500 sm:text-sm",
            displayValue: __props.allowMultiple ? (territories) => territories.map((t) => t.name) : (t) => t.name,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (territoryQuery.value = $event.target.value))
          }, null, 8, ["displayValue"]),
          _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden" }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectorIcon, {
                "aria-hidden": "true",
                class: "w-5 h-5 text-gray-400"
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(ComboboxOptions), { class: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTerritories.value, (territory) => {
                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                  key: territory.id,
                  value: territory,
                  as: "template"
                }, {
                  default: _withCtx(({ active, selected }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-electric-600 text-white' : 'text-gray-900'])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                      }, _toDisplayString(territory.name), 3),
                      selected
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(['absolute inset-y-0 flex items-center pl-1.5', active ? 'text-white' : 'text-electric-600'])
                          }, [
                            _createVNode(_unref(CheckIcon), {
                              "aria-hidden": "true",
                              class: "w-5 h-5"
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "multiple"])
  ]))
}
}

})